import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { message } from 'antd';
import React, { useEffect, useState } from 'react';

// Which install grammar the visitor prefers. Remembered across skill pages
// (same pattern as the theme preference) so an OpenClaw user picks once.
const CHANNEL_STORAGE_KEY = 'cellcog_skill_install_channel';

const CHANNELS = [
  {
    id: 'npx',
    label: 'npx',
    caption: 'Claude Code, Cursor, Codex + 70 more agents',
    command: (name) => `npx skills add cellcog/skills --skill ${name}`,
  },
  {
    id: 'openclaw',
    label: 'OpenClaw',
    caption: 'via ClawHub',
    command: (name) => `openclaw skills install @cellcog/${name}`,
  },
];

const SkillInstallCard = ({ skillName }) => {
  const [channelId, setChannelId] = useState('npx');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(CHANNEL_STORAGE_KEY);
      if (saved && CHANNELS.some((c) => c.id === saved)) setChannelId(saved);
    } catch {
      // storage unavailable — default stands
    }
  }, []);

  const selectChannel = (id) => {
    setChannelId(id);
    setCopied(false);
    try {
      localStorage.setItem(CHANNEL_STORAGE_KEY, id);
    } catch {
      // storage unavailable — selection still applies for this page
    }
  };

  const channel = CHANNELS.find((c) => c.id === channelId) || CHANNELS[0];
  const command = channel.command(skillName);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
      message.success('Install command copied');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      message.error('Failed to copy');
    }
  };

  return (
    <div className="skill-install-card">
      <div className="skill-install-tabs" role="tablist" aria-label="Install method">
        {CHANNELS.map((c) => (
          <button
            key={c.id}
            type="button"
            role="tab"
            aria-selected={c.id === channelId}
            className={`skill-install-tab${c.id === channelId ? ' active' : ''}`}
            onClick={() => selectChannel(c.id)}
          >
            {c.label}
          </button>
        ))}
      </div>
      <div className="skill-install-row">
        <code className="skill-install-command">{command}</code>
        <button
          type="button"
          className="skill-install-copy"
          onClick={handleCopy}
          aria-label="Copy install command"
        >
          {copied ? <CheckOutlined /> : <CopyOutlined />}
        </button>
      </div>
      <div className="skill-install-caption">{channel.caption}</div>
    </div>
  );
};

export default SkillInstallCard;
